import React from "react";
import striptags from "striptags";
import { parseHtml } from "../../../utils/common";

const OverviewSection = ({ serviceDetail }) => {
  const titleWithoutPTag = serviceDetail?.value?.title;
  return (
    <section className="overview-section">
      <div className="services-overview-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-xl-3">
              <div className="services-overview-title">
                <span itemProp="heading" dangerouslySetInnerHTML={{
                  __html: titleWithoutPTag,
                }} ></span>

              </div>
            </div>
            <div className="col-lg-9 col-xl-9">
              <div className="services-overview-content">
                <div className="overview-short-description">
                  {parseHtml(serviceDetail?.value?.description)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
